"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// WHAT THE INVESTIGATION BUTTONS RETURN: the facilitator's choice of result for each investigation
// (ECG, VBG, X-ray, Urine, POCUS, CT), before START or during the run, in every mode.
//
//   - ResultsPanel lists each investigation with the result its button on the room monitor gives now
//     (the scenario's own unless changed), with Change and Undo.
//   - ResultEditor is the chooser: library findings with real images, report-only findings, presets
//     (VBG, urine dipstick, POCUS), typed VBG values and a typed report.
//   - LiveResults wires the two to a running simulation (data/engine.js): a choice rewrites the
//     scenario's result fields through INVESTIGATIONS.setResult, so the sync payload carries it to the
//     room monitor and nothing new is synced or stored. Choosing sends nothing to the monitor;
//     each row's Send button puts that result on the patient screens straight away, whenever the
//     facilitator wants (every mode, including Quick Sim and Defib Sim, which have no other way).
//
// The Builder uses ResultsPanel and ResultEditor with its own list of choices (scenario.invResults),
// applied when the scenario runs (INVESTIGATIONS.applyResultSpecs).
(function () {
  var _React = React,
    useState = _React.useState;
  var INV = function INV() {
    return window.INVESTIGATIONS;
  };
  var SHORT = {
    ECG: '12-lead ECG',
    VBG: 'VBG',
    'X-ray': 'X-ray',
    Urine: 'Urine',
    POCUS: 'POCUS',
    CT: 'CT'
  };
  function ResultsPanel(_ref) {
    var rows = _ref.rows,
      onEdit = _ref.onEdit,
      onReset = _ref.onReset,
      onSend = _ref.onSend,
      sent = _ref.sent,
      intro = _ref.intro,
      resetTitle = _ref.resetTitle;
    var _window = window,
      Lucide = _window.Lucide;
    var I = INV();
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "inv-results-panel"
    }, intro && /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mb-2"
    }, intro), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 lg:grid-cols-2 gap-1.5"
    }, rows.map(function (r) {
      var img = r.image && I ? I.imageFor(r.image) : null;
      return /*#__PURE__*/React.createElement("div", {
        key: r.type,
        "data-testid": "inv-result-row-".concat(r.type),
        className: "flex gap-2 items-center p-1.5 rounded border ".concat(r.changed ? 'border-amber-500/70 bg-amber-950/20' : 'border-slate-700 bg-slate-900')
      }, img ? /*#__PURE__*/React.createElement("img", {
        src: img.src,
        alt: "",
        className: "w-10 h-8 object-cover rounded flex-none bg-white",
        loading: "lazy"
      }) : /*#__PURE__*/React.createElement("div", {
        className: "w-10 h-8 rounded flex-none bg-slate-800 flex items-center justify-center"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "file-text",
        className: "w-4 h-4 text-slate-500"
      })), /*#__PURE__*/React.createElement("div", {
        className: "min-w-0 flex-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[11px] font-bold text-slate-100 flex items-center gap-1.5"
      }, SHORT[r.type] || r.type, r.changed && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] uppercase tracking-wide text-amber-300 font-bold",
        "data-testid": "inv-result-changed"
      }, "Changed")), /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-slate-400 line-clamp-2",
        title: r.text || ''
      }, r.changed && r.label ? /*#__PURE__*/React.createElement("b", {
        className: "text-amber-200"
      }, r.label, ": ") : null, r.text || 'Image only.'), r.note && /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-sky-300",
        "data-testid": "inv-result-note-".concat(r.type)
      }, r.note), r.ecgImageNotFitting && /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-amber-300"
      }, "The chosen ECG does not match the current rhythm, so the 12-lead is drawn from the rhythm.")), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-1 flex-none"
      }, onSend && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return onSend(r.type);
        },
        "data-testid": "inv-send-".concat(r.type),
        "aria-label": "Send the ".concat(SHORT[r.type] || r.type, " result to the patient screens now"),
        className: "text-[10px] uppercase font-bold px-2 py-1 rounded border ".concat(sent === r.type ? 'border-emerald-400 bg-emerald-800 text-white' : 'border-purple-400 bg-purple-700 text-white hover:bg-purple-600')
      }, sent === r.type ? 'Sent' : 'Send'), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return onEdit(r.type);
        },
        "aria-label": "Change the ".concat(SHORT[r.type] || r.type, " result"),
        className: "text-[10px] uppercase font-bold px-2 py-1 rounded border border-sky-600 text-sky-300 hover:bg-sky-900/40"
      }, "Change"), r.changed && onReset && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return onReset(r.type);
        },
        "aria-label": "Undo the ".concat(SHORT[r.type] || r.type, " change"),
        title: resetTitle || '',
        className: "text-[10px] uppercase font-bold px-2 py-1 rounded border border-slate-600 text-slate-300 hover:bg-slate-700"
      }, "Undo")));
    })));
  }
  function ResultEditor(_ref2) {
    var type = _ref2.type,
      current = _ref2.current,
      currentVbg = _ref2.currentVbg,
      onPick = _ref2.onPick,
      onReset = _ref2.onReset,
      onClose = _ref2.onClose,
      resetLabel = _ref2.resetLabel,
      rhythmLabel = _ref2.rhythmLabel;
    var _window2 = window,
      Modal = _window2.Modal,
      Button = _window2.Button,
      Lucide = _window2.Lucide;
    var I = INV();
    var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      text = _useState2[0],
      setText = _useState2[1];
    var startVbg = currentVbg || (window.generateVbg ? window.generateVbg('normal') : {});
    var toFields = function toFields(v) {
      var o = {};
      I.VBG_FIELDS.forEach(function (f) {
        o[f.k] = v && Number.isFinite(Number(v[f.k])) ? String(v[f.k]) : '';
      });
      return o;
    };
    var _useState3 = useState(function () {
        return toFields(startVbg);
      }),
      _useState4 = _slicedToArray(_useState3, 2),
      vbg = _useState4[0],
      setVbg = _useState4[1];
    var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      vbgPreset = _useState6[0],
      setVbgPreset = _useState6[1];
    var vbgErrors = I.VBG_FIELDS.filter(function (f) {
      var raw = vbg[f.k];
      if (raw === '' || raw === undefined) return !f.optional;
      var n = Number(raw);
      return !Number.isFinite(n) || n < f.min || n > f.max;
    }).map(function (f) {
      return f.k;
    });
    var findings = I.FINDINGS[type] || [];
    var withImage = findings.filter(function (f) {
        return f.image;
      }),
      reportOnly = findings.filter(function (f) {
        return !f.image;
      });
    var pick = function pick(spec) {
      onPick(spec);
    };
    var opt = 'text-left px-3 py-1.5 bg-slate-700 hover:bg-slate-600 text-xs text-slate-100 rounded border border-slate-600';
    var lbl = 'text-xs text-slate-400 font-bold uppercase mb-2 block';
    return /*#__PURE__*/React.createElement(Modal, {
      fixed: true,
      label: "".concat(type, " result"),
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-5 rounded-lg border border-slate-600 w-full max-w-lg shadow-2xl max-h-[90vh] flex flex-col",
      "data-testid": "inv-result-editor"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-3 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, type, " result"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400"
    }, "What the team gets when they press ", type === 'ECG' ? '12-Lead' : type === 'X-ray' ? 'CXR' : type === 'CT' ? 'CT Head' : type, " on the patient monitor. Choosing here sends nothing.")), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close without changing",
      onClick: onClose,
      className: "text-slate-400 hover:text-white flex-none"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), current && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border border-slate-700 rounded p-2 mb-3 text-[11px] text-slate-300",
      "data-testid": "inv-editor-current"
    }, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-100"
    }, "Now:"), " ", current.changed && current.label ? "".concat(current.label, ". ") : '', current.text || 'Image only.'), /*#__PURE__*/React.createElement("div", {
      className: "space-y-4 overflow-y-auto flex-grow pr-1"
    }, type === 'ECG' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "".concat(opt, " w-full"),
      onClick: function onClick() {
        return pick({
          ecgLive: true
        });
      }
    }, /*#__PURE__*/React.createElement("b", null, "Drawn from the live rhythm"), rhythmLabel ? " (now ".concat(rhythmLabel, ")") : ''), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mt-1"
    }, "A real 12-lead shows only while the patient is in a rhythm it fits (for example a STEMI tracing in sinus rhythm). Otherwise the 12-lead is drawn from the rhythm.")), type === 'VBG' && /*#__PURE__*/React.createElement("div", {
      "data-testid": "inv-vbg-editor"
    }, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Start from"), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1 mb-2"
    }, I.VBG_PRESETS.map(function (p) {
      return /*#__PURE__*/React.createElement("button", {
        key: p.id,
        type: "button",
        onClick: function onClick() {
          setVbg(toFields(window.generateVbg ? window.generateVbg(p.id) : {}));
          setVbgPreset(p.id);
        },
        className: "text-[11px] px-2 py-1 rounded border ".concat(vbgPreset === p.id ? 'border-sky-400 bg-sky-900/40 text-white' : 'border-slate-600 bg-slate-700 text-slate-200 hover:bg-slate-600')
      }, p.label);
    })), /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Values"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-2"
    }, I.VBG_FIELDS.map(function (f) {
      return /*#__PURE__*/React.createElement("label", {
        key: f.k,
        className: "text-[11px] text-slate-300 flex flex-col gap-0.5"
      }, f.label, /*#__PURE__*/React.createElement("input", {
        type: "number",
        inputMode: "decimal",
        step: f.step,
        min: f.min,
        max: f.max,
        value: vbg[f.k],
        "aria-label": f.label,
        "data-testid": "vbg-".concat(f.k),
        onChange: function onChange(e) {
          var v = e.target.value;
          setVbg(function (o) {
            return Object.assign({}, o, _defineProperty({}, f.k, v));
          });
          setVbgPreset(null);
        },
        className: "bg-slate-900 border rounded px-2 h-8 text-sm text-white ".concat(vbgErrors.indexOf(f.k) !== -1 ? 'border-red-500' : 'border-slate-600')
      }));
    })), vbgErrors.length > 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-red-300 mt-1"
    }, "Check: ", vbgErrors.map(function (k) {
      return (I.VBG_FIELDS.filter(function (f) {
        return f.k === k;
      })[0] || {}).label;
    }).join(', '), "."), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mt-1"
    }, "These are the values the team gets now, and the pH and K+ become the patient's. The gas still changes with time and treatment (ventilation, shock, insulin, bicarbonate)."), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return pick({
          vbg: I.cleanVbg(vbg, startVbg),
          preset: vbgPreset
        });
      },
      variant: "primary",
      className: "w-full mt-2",
      disabled: vbgErrors.length > 0
    }, "Use these values")), type === 'Urine' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Dipstick"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-1.5"
    }, I.URINE_PRESETS.map(function (p) {
      return /*#__PURE__*/React.createElement("button", {
        key: p.id,
        type: "button",
        className: opt,
        onClick: function onClick() {
          return pick({
            urine: p.id
          });
        }
      }, p.label);
    }))), type === 'POCUS' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Quick results"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-1.5"
    }, I.POCUS_PRESETS.map(function (p) {
      return /*#__PURE__*/React.createElement("button", {
        key: p.id,
        type: "button",
        className: opt,
        onClick: function onClick() {
          return pick({
            pocus: p.id
          });
        }
      }, p.label);
    }))), withImage.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Results with a real image"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
      "data-testid": "inv-editor-library"
    }, withImage.map(function (f) {
      var img = I.imageFor(f.image);
      return /*#__PURE__*/React.createElement("button", {
        key: f.id,
        type: "button",
        onClick: function onClick() {
          return pick({
            findingId: f.id
          });
        },
        title: f.report,
        className: "text-left flex gap-2 items-center p-1.5 bg-slate-700 hover:bg-slate-600 rounded border border-slate-600"
      }, /*#__PURE__*/React.createElement("img", {
        src: img.src,
        alt: "",
        className: "w-14 h-11 object-cover rounded flex-none bg-white",
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-xs text-slate-100 leading-tight"
      }, f.label));
    }))), reportOnly.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "More results (written report only)"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 gap-1.5"
    }, reportOnly.map(function (f) {
      return /*#__PURE__*/React.createElement("button", {
        key: f.id,
        type: "button",
        className: opt,
        title: f.report,
        onClick: function onClick() {
          return pick({
            findingId: f.id
          });
        }
      }, f.label);
    }))), type !== 'VBG' && type !== 'ECG' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: lbl
    }, "Your own report"), /*#__PURE__*/React.createElement("textarea", {
      value: text,
      onChange: function onChange(e) {
        return setText(e.target.value);
      },
      "aria-label": "Your own ".concat(type, " report"),
      "data-testid": "inv-editor-text",
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm h-20",
      placeholder: "Type the report the team will see..."
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return pick({
          text: text.trim()
        });
      },
      variant: "primary",
      className: "w-full mt-2",
      disabled: !text.trim()
    }, "Use this report"))), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-3 mt-2 flex-shrink-0 grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outline",
      className: "w-full"
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      onClick: onReset,
      variant: "secondary",
      className: "w-full",
      disabled: !current || !current.changed
    }, resetLabel || "Scenario's own result"))));
  }

  // The panel and chooser wired to a running simulation.
  function LiveResults(_ref3) {
    var sim = _ref3.sim,
      addLogEntry = _ref3.addLogEntry,
      intro = _ref3.intro,
      _ref3$canSend = _ref3.canSend,
      canSend = _ref3$canSend === void 0 ? true : _ref3$canSend;
    var I = INV();
    var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      editing = _useState8[0],
      setEditing = _useState8[1];
    var _useState9 = useState(null),
      _useState0 = _slicedToArray(_useState9, 2),
      sent = _useState0[0],
      setSent = _useState0[1];
    var state = sim.state;
    var scenario = state.scenario;
    if (!I || !scenario) return null;
    var RG = window.RHYTHMS;
    // pH and K+ are not obs: the VBG reports the patient's own pH and K+ (window.liveVbg), so the
    // VBG row shows the gas the team would get now and choosing a gas sets the patient's pH and K+.
    var liveGas = window.liveVbg ? window.liveVbg(scenario, state.vitals, state.activeInterventions, state.time) : null;
    var rows = I.RESULT_TYPES.map(function (type) {
      var row = Object.assign({
        type: type
      }, I.currentResult(scenario, type, state.rhythm));
      if (type === 'VBG' && liveGas) {
        row.text = I.vbgSummary(liveGas);
        row.note = "pH and K+ are the patient\u2019s own and change with treatment. Change sets them.";
      }
      return row;
    });
    var apply = function apply(type, spec) {
      var next = I.setResult(scenario, type, spec);
      sim.dispatch({
        type: 'UPDATE_SCENARIO',
        payload: next
      });
      if (addLogEntry) addLogEntry(spec ? "".concat(type, " result set: ").concat(I.specLabel(type, spec)) : "".concat(type, " result back to the scenario's own"), 'system');
      if (type === 'VBG') {
        var gas = next.vbg || (next.investigations || {}).vbg || null;
        var set = {};
        if (gas && Number.isFinite(Number(gas.pH))) set.ph = Number(gas.pH);
        if (gas && Number.isFinite(Number(gas.K))) set.k = Number(gas.K);
        if (Object.keys(set).length && sim.manualUpdateVitals) sim.manualUpdateVitals(set);
      }
      setEditing(null);
    };
    // Send it now: the same as the team pressing that button on the patient monitor, so the
    // monitor shows the result as it is set here (the scenario's own unless changed), with its image.
    var send = function send(type) {
      if (!sim.revealInvestigation) return;
      sim.revealInvestigation(type, null, {});
      setSent(type);
      setTimeout(function () {
        return setSent(function (t) {
          return t === type ? null : t;
        });
      }, 2500);
    };
    // Take a result or image back off the patient screens. The controller only knows what it sent;
    // the button also clears a result the team opened on the monitor themselves.
    var popup = state.monitorPopup || {};
    var showing = popup.type ? SHORT[popup.type] || popup.type : null;
    var clear = function clear() {
      if (!sim.clearInvestigation) return;
      sim.clearInvestigation();
      setSent(null);
      if (addLogEntry) addLogEntry('Results and images cleared from the patient screens', 'system');
    };
    var cur = editing ? rows.filter(function (r) {
      return r.type === editing;
    })[0] : null;
    var scenarioVbg = liveGas || scenario.vbg || (scenario.investigations || {}).vbg || null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, canSend && sim.clearInvestigation && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 mb-2 p-1.5 rounded border border-slate-700 bg-slate-900",
      "data-testid": "inv-on-screens"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 text-[11px] text-slate-300"
    }, showing ? /*#__PURE__*/React.createElement(React.Fragment, null, "On the patient screens: ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, showing)) : 'Nothing sent to the patient screens just now.'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: clear,
      "data-testid": "inv-clear-screens",
      "aria-label": "Clear results and images from the patient screens",
      className: "flex-none text-[10px] uppercase font-bold px-2 py-1.5 rounded border border-red-500 text-red-200 hover:bg-red-900/40"
    }, "Clear screens")), /*#__PURE__*/React.createElement(ResultsPanel, {
      rows: rows,
      onEdit: setEditing,
      onReset: function onReset(t) {
        return apply(t, null);
      },
      resetTitle: "Back to the scenario's own result",
      onSend: canSend ? send : null,
      sent: sent,
      intro: intro === undefined ? canSend ? "What each investigation button on the patient monitor gives. Send puts a result on the patient screens now, at any time. Change any of them before START or during the run; changing sends nothing." : "What each investigation button on the patient monitor gives. Change any of them before START or during the run; nothing is sent until the team (or you) asks for the result." : intro
    }), editing && /*#__PURE__*/React.createElement(ResultEditor, {
      type: editing,
      current: cur,
      currentVbg: scenarioVbg,
      rhythmLabel: RG ? RG.labelFor(state.rhythm) : state.rhythm,
      onPick: function onPick(spec) {
        return apply(editing, spec);
      },
      onReset: function onReset() {
        return apply(editing, null);
      },
      onClose: function onClose() {
        return setEditing(null);
      }
    }));
  }
  window.InvResults = {
    ResultsPanel: ResultsPanel,
    ResultEditor: ResultEditor,
    LiveResults: LiveResults
  };
})();